import { ButtonWrapper } from '../../../base/Dropdown/shared/styles';
import {
  ButtonContent,
  HeaderContent,
  HeaderButton,
} from '../../../data-visualization/Table/DropdownHead.style';
import { Toolbar } from '../../../utility/GenericComponent/GenericComponent';
import styled, { css } from 'styled-components/macro';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import TableBody from 'components/data-visualization/Table/Body';
import Layout from 'components/styled/Layout/Layout';
import Button from 'components/elements/button';

export const markers = css`
  span {
    border-radius: 50%;

    &.disc {
      display: inline-block;
      height: 10px;
      min-width: 10px;
      background-color: ${({ theme }): string => theme.Blue};
    }
    &.rhombus {
      border-radius: 0;
      display: inline-block;
      min-height: 8px;
      min-width: 8px;
      transform: rotate(45deg);
      background-color: #f0cc00;
    }
    &.bordered-plus {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 17px;
      min-width: 17px;
      color: ${({ theme }): string => theme.MediumGrey};
      border: 1px dashed ${({ theme }): string => theme.MediumGrey};
      padding-top: 2px;
    }
  }
`;

export const PlaylistComponentWrapper = styled('div')<any>`
  & > section {
    width: auto;
    ${Layout.MaxWidth} {
      width: 95% !important;
    }
    @media screen and (min-width: 50em) {
      width: 90%;
    }
    @media screen and (min-width: 80em) {
      width: 75%;
    }

    ${css`
      @media screen and (max-width: 50em) {
        margin: 0.5rem;
      }
      @media screen and (max-width: 40em) {
        padding: ${({ theme }): string => `${theme.spacing.small} 0`};
      }
    `}
  }
  ${AnimatedLoadingWrapper} {
    padding: 0;
    margin-top: 1em;
  }
  ${TableBody} {
    padding-right: 0;
  }

  ${Toolbar} {
    transform: none;
    padding: ${({ theme }): string =>
      `${theme.spacing.small} 0 ${theme.spacing.medium} 0`};

    @media screen and (min-width: 40em) {
      padding: ${({ theme }): string =>
        `${theme.spacing.large} ${theme.spacing.small} ${theme.spacing.small} 0`};
    }
  }

  ${HeaderButton} {
    padding: 0;
  }

  @media screen and (max-width: 65em) {
    ${ButtonContent} {
      width: 1.2rem;
      height: 1.2rem;
    }
  }

  ${HeaderContent} {
    display: flex;
    text-align: center;
  }

  ${ButtonWrapper} {
    padding: ${({ theme }): string =>
      `${theme.spacing.medium} ${theme.spacing.small}`};
  }

  ${markers}
`;

export const DropdownWrapper = styled('div')<any>`
  div > button > div {
    padding: ${({ isSmallScreen }): string =>
      isSmallScreen ? '1em 0.5787037037037037em' : '9px 21px'} !important;
  }
`;

export const ModalWrapper = styled('div')`
  ${markers}
  span {
    margin-top: 0;
  }
`;

export const DottedLine = styled('div')`
  display: inline-block;
  border-top: 1px dashed #95adc2;
  width: 95px;
  padding-bottom: 3.5px;
  margin-top: 30px;
`;

export const GreenButton = styled('button')<{
  width: string;
  disabled?: boolean;
}>`
  width: ${({ width }): string => width};
  padding: 0.6875rem 2.6875rem;
  background-color: ${({ theme }): string => theme.AccentGreen};
  color: ${({ theme }): string => theme.White};
  font-size: 18px;
  font-weight: 600;
  opacity: ${({ disabled }): string => (disabled ? '0.3' : '1')};
`;

export const UnderlinedButton = styled('button')`
  margin-top: 2rem;
  font-size: 1rem;
  text-decoration: underline;
`;

export const CloseButton = styled(Button)`
  display: flex;
  padding: 0;
  g {
    stroke: #95adc2;
  }

  @media screen and (max-width: 500px) {
    position: absolute;
    top: 35px;
    right: 35px;
  }
`;

export const IconName = styled('p')`
  margin: 0;
  display: inline;
  font-size: 14px;
  font-weight: 700;
  color: #000000;
`;

export const InfoText = styled('span')`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #8ea6be;
  margin: 0 20px 0 12px;
  min-width: 60px;
`;

export const InfoTextWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const InnerTextWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

export const PaginationTotalWrapper = styled('div')`
  span {
    margin: 0 auto;
  }
`;
